import { render, staticRenderFns } from "./EnableWifi.vue?vue&type=template&id=b4b9c468"
import script from "./EnableWifi.vue?vue&type=script&lang=ts"
export * from "./EnableWifi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports